module.exports = __webpack_public_path__ + "img/700.32ac619e.png";